import { ReactNode, useRef, useState } from 'react'

import { Box, Icon } from '@factorialco/deprecated-design-system'
import * as Dialog from '@radix-ui/react-dialog'

import { track, trackingEvents } from 'modules/core/lib/Tracking'

import './index.styles.css'
type Props = {
  children?: ReactNode
  src: string
  video?: boolean
  productUpdateSlug?: string
  openDialog?: boolean
  autoPlay?: boolean
}

const ClickableMedia = ({
  children,
  src,
  video,
  productUpdateSlug,
  openDialog,
  autoPlay = false,
}: Props) => {
  const [isPlaying, setIsPlaying] = useState(autoPlay)
  const videoRef = useRef<HTMLVideoElement>(null)

  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play()
      setIsPlaying(true)
    }
  }

  if (!openDialog) {
    return (
      <Box
        borderRadius={{ all: 'abs016' }}
        border={{
          all: {
            color: 'grey400',
            width: 's1',
            style: 'solid',
          },
        }}
        className={'ClickableMedia_imgContainer'}
        overflowX="hidden"
        alignSelf="center"
        position="relative"
        width="full"
      >
        {video ? (
          <>
            <video
              ref={videoRef}
              controls={isPlaying}
              src={src}
              autoPlay={autoPlay}
              style={{ height: '340px', display: 'block' }}
            ></video>
            {!isPlaying && (
              <button
                onClick={handlePlay}
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  background: 'rgba(0, 0, 0, 0.5)',
                  border: 'none',
                  borderRadius: '50%',
                  width: '80px',
                  height: '80px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Icon.Medium icon="play-filled" />
              </button>
            )}
          </>
        ) : (
          <img src={src} />
        )}
      </Box>
    )
  }

  return (
    <Dialog.Root>
      <Dialog.Trigger
        className={'ClickableMedia_trigger'}
        onClick={() => {
          track(trackingEvents.productUpdates.clickImageProductUpdate, {
            productUpdateSlug: productUpdateSlug,
          })
        }}
      >
        {children}
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className={'ClickableMedia_overlay'} />
        <Dialog.Content className={'ClickableMedia_modalBox'}>
          <Box
            borderRadius={{ all: 'abs016' }}
            className={'ClickableMedia_imgContainer'}
            overflowX="hidden"
            alignSelf="center"
          >
            {video ? <video controls src={src} autoPlay loop></video> : <img src={src} />}
          </Box>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}

export default ClickableMedia
